import React from 'react';
import './DeleteAllNotificationsDrawer.css';

function DeleteAllNotificationsDrawer({ onClose, onConfirm }) {
  return (
    <div className="deleteallnotif-overlay" onClick={onClose}>
      <div
        className="deleteallnotif-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Delete All Notifications?</h3>
        <p>All notifications will be removed from your list. You cannot undo this.</p>

        <div className="deleteallnotif-actions">
          <button className="deleteallnotif-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="deleteallnotif-confirm-btn" onClick={onConfirm}>
            Delete All
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteAllNotificationsDrawer;
